import React from "react";
import GhostBar from "./GhostBar";

const GhostSpendSafeguards = ({ count = 3 }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          className="rule-item"
          key={`ghost-rule-${index}`}
          style={{
            borderBottom: index === count - 1 ? "none" : "1px solid #E5E7EB",
            cursor: "default",
          }}
        >
          {/* Left Block: Name representation and descriptive sub-text */}
          <div className="rule-item-left" style={{ width: "65%" }}>
            <div
              className="rule-item-left-name-container"
              style={{ display: "flex", gap: "10px", alignItems: "center" }}
            >
              <GhostBar width="160px" height="16px" /> {/* Rule Name */}
              <GhostBar
                width="60px"
                height="18px"
                style={{ borderRadius: "12px" }}
              />{" "}
              {/* System/Custom Tag */}
            </div>
            <div style={{ marginTop: "8px" }}>
              <GhostBar width="85%" height="12px" /> {/* Description Row 1 */}
            </div>
          </div>

          {/* Right Block: Amount threshold metrics and action menu selectors */}
          <div
            className="rule-item-right"
            style={{ display: "flex", alignItems: "center", gap: "12px" }}
          >
            <div style={{ marginRight: "12px" }}>
              <GhostBar width="50px" height="16px" /> {/* Trigger Amount */}
            </div>

            <div
              className="item-actions"
              style={{ gap: "12px", alignItems: "center" }}
            >
              {/* Switch Box Skeleton Container */}
              <GhostBar
                width="34px"
                height="20px"
                style={{ borderRadius: "10px" }}
              />
              {/* Action Menu (Three-dot selector) */}
              {index > 0 && <GhostBar width="16px" height="16px" circle />}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GhostSpendSafeguards;
